import { render } from "./SceneTimeObject.vue?vue&type=template&id=12b6e76e&ts=true"
import script from "./SceneTimeObject.ts?vue&type=script&lang=ts"
export * from "./SceneTimeObject.ts?vue&type=script&lang=ts"

import "./SceneTimeObject.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__